import {
    FilterSummary,
    FilterSummaryStatus,
    FilterSummaryContainer,
    FilterSummaryClose,
} from './FilterSummary.tsx';
import { FilterStatusIcon } from './FilterStatusIcon.tsx';
import { Maybe } from 'dg-web-shared/lib/MaybeV2.ts';
import React, { useState, type JSX } from 'react';

interface Props {
    onFilterClick: Maybe<() => void>;
    clearFilter: () => void;
    children?: React.ReactNode;
}

export function FilterButtonWithSummary({
    onFilterClick,
    clearFilter,
    children,
}: Props): JSX.Element {
    const [hover, setHover] = useState(false);

    return (
        <FilterSummary hover={hover}>
            <FilterSummaryStatus>
                <FilterStatusIcon
                    clickable={!!onFilterClick}
                    active={!!children}
                    onClick={onFilterClick}
                />
            </FilterSummaryStatus>
            {children && (
                <FilterSummaryContainer>
                    {children}
                    <FilterSummaryClose
                        onClick={() => {
                            clearFilter();
                            setHover(false);
                        }}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                    />
                </FilterSummaryContainer>
            )}
        </FilterSummary>
    );
}
